import React from "react";
import { useDispatch } from "react-redux";
import { show } from "redux-modal";
import { Button } from "src/components";
import { useTheme } from "src/hooks/useTheme";
import { colors } from "src/theme";

const FullServiceMarketing: React.FC = () => {
  const dispatch = useDispatch();

  const features = [
    {
      title: "Quarterly Updates",
      icon: "fa-sharp fa-calendar-alt",
      description:
        "Stay informed with regular updates on your crypto tax situation throughout the year.",
    },
    {
      title: "Year-Round Bookkeeping",
      icon: "fa-sharp fa-book",
      description:
        "We handle all your crypto transaction tracking and bookkeeping automatically.",
    },
    {
      title: "Minimal Client Input",
      icon: "fa-sharp fa-user-check",
      description:
        "We only reach out when we have specific questions, keeping your involvement minimal.",
    },
  ];

  const theme = useTheme();

  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Hero Section */}
      <section
        style={{
          padding: "40px 0 9px 0",
          backgroundColor: theme.medBackground,
          textAlign: "left",
        }}
      >
        <div
          style={{
            maxWidth: "1200px",
            padding: "0 40px",
          }}
        >
          <h1
            style={{
              fontSize: 48,
              fontWeight: 800,
              lineHeight: 1.1,
              marginBottom: "20px",
              fontStretch: "expanded",
              color: theme.header,
            }}
          >
            <span style={{ display: "block" }}>Full Service</span>
            <span
              style={{
                display: "block",
                // background: `linear-gradient(135deg, #FFD700, #FFA500)`,
                // WebkitBackgroundClip: "text",
                // WebkitTextFillColor: "transparent",
                // backgroundClip: "text",
              }}
            >
              Crypto Taxes
            </span>
          </h1>
          <p
            style={{
              fontSize: 18,
              fontWeight: "medium",
              color: theme.text,
              maxWidth: "700px",
              lineHeight: 1.4,
            }}
          >
            Let us handle your crypto taxes for you. We'll review your
            transactions throughout the year so you can file with ease.
            <br />
            <br />
            <b>IMPORTANT:</b> you must request this in advance of tax season so
            we have enough time to help you. Limited availability.
          </p>
        </div>
      </section>

      {/* Features Section */}
      <section
        style={{
          backgroundColor: theme.medBackground,
          minHeight: "auto",
          padding: "15px 40px",
        }}
      >
        <div>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
              gap: "10px",
              marginBottom: 25,
            }}
          >
            {features.map((feature, index) => (
              <div
                key={index}
                style={{
                  padding: 25,
                  borderRadius: 15,
                  border: `1px solid ${theme.ternaryBackground}`,
                  background: theme.medBackground,
                  transition: "transform 0.3s ease, box-shadow 0.3s ease",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "20px",
                  }}
                >
                  <i
                    className={feature.icon}
                    style={{
                      color: colors.yellow40,
                      fontSize: "24px",
                      marginRight: "15px",
                    }}
                  ></i>
                  <h3
                    style={{
                      fontSize: "1.25rem",
                      fontWeight: 600,
                      color: theme.header,
                    }}
                  >
                    {feature.title}
                  </h3>
                </div>
                <p
                  style={{
                    color: theme.text,
                    lineHeight: 1.6,
                  }}
                >
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section
        style={{
          flex: 1,
          marginTop: 0,
          backgroundColor: theme.medBackground,
          padding: "15px 40px",
        }}
      >
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: "40px",
            }}
          >
            <h2
              style={{
                fontSize: "2rem",
                fontWeight: 700,
                lineHeight: 1.3,
                fontStretch: "expanded",
                maxWidth: 800,
              }}
            >
              <span style={{ display: "block", color: theme.header }}>
                Ready to simplify your crypto taxes?
              </span>
              <span
                style={{
                  display: "block",
                  fontWeight: "normal",
                  marginTop: 15,
                  fontStretch: "normal",
                  color: theme.text,
                  fontSize: 18,
                }}
              >
                Tell us about your needs, and we'll circle back if it's a good
                fit. Starts at $149/month (12 month commitment).
              </span>
              <Button
                style={{
                  marginTop: 40,
                  width: 200,
                  padding: "25px 0",
                  background: `linear-gradient(45deg, #FFD700 0%, #FFA500 100%)`,
                  color: colors.black,
                  fontSize: 18,
                  textDecoration: "none",
                  fontWeight: "bold",
                  borderRadius: 15,
                  transition: "background-color 0.3s ease",
                }}
                onClick={() => {
                  dispatch(
                    show("FeedbackModal", {
                      hiddenDescription: "Full Service Application",
                      customTitle: "Apply for Full Service",
                      customBody:
                        "In order to best help you, tell us a little bit about your needs and what you are looking for. We'll circle back as soon as possible.",
                    })
                  );
                }}
              >
                Apply Now{" "}
                <i
                  className="fa-solid fa-chevron-double-right"
                  style={{
                    marginLeft: 5,
                    position: "absolute",
                    right: 10,
                  }}
                ></i>
              </Button>
            </h2>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FullServiceMarketing;
